










import { ClassificacaoTributaria } from '@/models/fiscal/ClassificacaoTributaria'
import { FindClassificacaoTributariaUseCase } from '@/usecases/impostos/cfop/FindClassificacaoTributariaUseCase'
import { Vue, Component } from 'vue-property-decorator'
import { VAutocomplete, VTextField } from 'vuetify/lib'

@Component({
	components: {
		VAutocomplete,
		VTextField,
	},
})
export default class SeletorDeClassificacaoTributaria extends Vue {
	codigosClassificacaoTributaria: ClassificacaoTributaria[] = []

	findUseCase = new FindClassificacaoTributariaUseCase()

	async created() {
		this.codigosClassificacaoTributaria = await  this.findUseCase.findAll()
	}

	get csts() {
		return this.codigosClassificacaoTributaria.sort((a, b) => a.codigo.localeCompare(b.codigo))
	}
}
